import '.a{display:flex;}.ssr-plugin'
import '.ab{align-items:stretch;}.ssr-plugin'
import '.b{justify-content:center;}.ssr-plugin'
import '.m{flex-direction:column;}.ssr-plugin'
import '.cr{background:var(--shades-white);}.ssr-plugin'
import '.ba{flex-grow:1;}.ssr-plugin'
import '.n{align-items:center;}.ssr-plugin'
import '.b7{max-width:77.5rem;}.ssr-plugin'
import '.d0{justify-content:stretch;}.ssr-plugin'
import '.d1{position:sticky;}.ssr-plugin'
import '.ck{top:0;}.ssr-plugin'
import '.d2{z-index:10;}.ssr-plugin'
import '.d3{padding-block:1rem;}.ssr-plugin'
import '.d4{height:3rem;}.ssr-plugin'
import '.a1{justify-content:space-between;}.ssr-plugin'
import '.d5{flex-wrap:wrap;}.ssr-plugin'
import '.d6{min-height:calc(100vh - 5rem);}.ssr-plugin'
import '.bi{margin-top:2rem;}.ssr-plugin'
import '.gb{padding-bottom:1.5rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const InitiativeCreatePageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="a ab b m cr"
      >
        <div className="ba a n b m"
        >
          <div className="b7 a m d0 d1 ck d2"
            style={{
              width: isMobile ? '100%' : '85%',
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            <nav className="d3 d4 a a1 n d5"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </nav>
          </div>
          <div className="d6 a m ab bi gb b7"
            style={{
              gap: gap,
              width: isMobile ? '100%' : '85%', // 8rem is padding + navbar height
              paddingInline: isMobile ? '5rem' : 0,}}
          >
            {children}
          </div>
        </div>
      </div>
    </ClientOnly>
  )
}
